import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { MediaVideo } from '@elfsight/widget-media-video';
import { openWindow } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import {
  ARROWS_CONTAINER_HEIGHT,
  IMAGE_OR_VIDEO_SLIDE_MIN_HEIGHT
} from '../../../../constants';

export const VideoSlide = ({
  data,
  onSlideLinkClick,
  active,
  isDrag,
  cloned = false,
  paginationHeight,
  navigationElementsVisibility,
  shouldForceMinHeight
}) => {
  const { editMode, arrowsPosition } = useSettings();

  const { video, autoplay, hideControls, muted, slideLink } = data;

  const videoRef = useRef();
  const isPlaying = useRef(autoplay);

  useEffect(() => {
    isPlaying.current = autoplay;
  }, [video?.originalValue, autoplay]);

  useEffect(() => {
    if (!active || !isPlaying.current) {
      videoRef.current?.pause();
    } else if (isPlaying.current) {
      videoRef.current?.play();
    }
    // oxlint-disable-next-line exhaustive-deps
  }, [active, videoRef.current, isPlaying.current]);

  const clickHandler = (e) => {
    if (isPlaying.current) {
      videoRef.current?.pause();
    } else {
      videoRef.current?.play();
    }

    if (isDrag) {
      e.preventDefault();
    }

    if (slideLink?.rawValue) {
      openWindow(slideLink.rawValue, {
        target: editMode ? '_blank' : slideLink.target
      });

      onSlideLinkClick?.(slideLink.rawValue);
    }
  };

  const onPlay = () => {
    isPlaying.current = true;
  };

  const onPause = () => {
    if (active) {
      isPlaying.current = false;
    }
  };

  const { arrows, pagination } = navigationElementsVisibility;

  const shouldHaveTopPadding = arrows && arrowsPosition.startsWith('top');
  const hasControls = !hideControls || !autoplay;

  const verticalPadding = [
    shouldHaveTopPadding ? ARROWS_CONTAINER_HEIGHT : 0,
    pagination ? paginationHeight : 0
  ];

  return (
    <>
      {!cloned && (
        <MediaVideo
          ref={videoRef}
          src={video?.originalValue}
          controls={hasControls}
          autoplay={autoplay}
          muted={muted}
          onPause={onPause}
          onPlay={onPlay}
          verticalPadding={hasControls ? verticalPadding : undefined}
          minHeight={
            shouldForceMinHeight ? IMAGE_OR_VIDEO_SLIDE_MIN_HEIGHT : undefined
          }
          shouldFill
        />
      )}
      {hideControls && autoplay && (
        <Overlay
          onClick={clickHandler}
          onDragStart={(e) => e.preventDefault()}
          _hasLink={!!slideLink?.value}
        />
      )}
    </>
  );
};

const Overlay = styled.div`
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  cursor: ${({ _hasLink }) => (_hasLink ? 'pointer' : 'inherit')};
`;
